import { Anchor, AspectRatio, Container, Text, Title } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { youtubeNocookieEmbedUrl } from '#marketing/lib/guide-registry.js';
import { localePath } from '#marketing/lib/marketing-locale.js';
import { useMarketingLocale } from '#marketing/lib/use-marketing-locale.js';

/**
 * Public /guides/:id page with a privacy-enhanced YouTube embed.
 * @param {object} props
 * @param {{ id: string, title: string, youtubeId: string }} props.guide
 */
export function MarketingGuidePage({ guide }) {
  const { t } = useTranslation('common');
  const locale = useMarketingLocale();
  const descriptionKey = `marketing.guides.videos.${guide.id}.description`;
  const description = t(descriptionKey);
  const embedUrl = youtubeNocookieEmbedUrl(guide.youtubeId, locale);

  return (
    <Container size="md" py="xl">
      <Text size="sm" mb="md">
        <Anchor component={Link} to={localePath(locale, '/guides')}>
          {t('marketing.guides.backToGuides')}
        </Anchor>
      </Text>

      <Title order={2} mb="sm">
        {guide.title}
      </Title>
      {description !== descriptionKey && (
        <Text c="dimmed" mb="lg" maw={640}>
          {description}
        </Text>
      )}

      <AspectRatio ratio={16 / 9} mb="xl">
        <iframe
          src={embedUrl}
          title={guide.title}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          loading="lazy"
          referrerPolicy="strict-origin-when-cross-origin"
          style={{ border: 0, borderRadius: 'var(--mantine-radius-md)' }}
        />
      </AspectRatio>
    </Container>
  );
}
